import { Directive, ElementRef, Input, HostListener } from "@angular/core";
import { ParticipationDataService } from '../_services/participation-data.service';
declare let $: any;
@Directive({
  selector: "[appTooltip]"
})
export class TooltipDirective {
  @Input() dataContext: any;
  @Input() IsButtonPanel: boolean = false;
  @Input() IsAnswerToolTip: boolean = false;
  @Input() IsHiddenQToolTip: boolean = false;
  @Input() qid: Number = 0;

  imageFolder: string;
  isShownHint: boolean = false;
  isTabKey: boolean = false;

  constructor(private ele: ElementRef, private service: ParticipationDataService) { }

  ngOnInit(): void {
    // Remove and Hide Tooltips on Document Click
    document.addEventListener("click", () => {
      let classNames = $(event.target).attr('class');
      if (classNames && (classNames.indexOf("tooltip_container") > -1 || classNames.indexOf("tooltip-text-wrapper")) > -1) {
        return;
      }
      let els = document.querySelectorAll(".tooltip_container");
      let datatooltip = document.getElementsByClassName('datatooltip');
      for (let i = 0; i < els.length; i++) {
        els[i].classList.remove("active");

        if (datatooltip.length > 0) {
          datatooltip[i].parentNode.removeChild(datatooltip[i]);
        }
      }
      this.isShownHint = false;
      this.isTabKey = false
    });

    this.imageFolder = this.service.getImageFolder();

  }

  // Hide Tooltips when Mouse is Move out on Web
  @HostListener('mouseout')
  @HostListener('blur')
  hideTooltip() {
    if (this.IsAnswerToolTip) {
      // Remove All Answer Tooltip
      let els = document.querySelectorAll(".answer,.hiddenQ-tooltip");
      for (let i = 0; i < els.length; i++) {
        els[i].classList.remove("active");
      }
    }
    else {
      if(this.isTabKey) {
        if($("#tooltip-" + this.qid).length > 0) {
          $("#tooltip-" + this.qid).remove()
          this.isTabKey = false
        }
      }
    }

  }

  // Listen to Mouseover, touchstart, click event on Tooltip icon
  @HostListener('mouseover',['$event'])
  @HostListener('touchstart',['$event'])
  @HostListener('click',['$event'])
  @HostListener('keydown',['$event'])
  @HostListener('focus',['$event'])
  showTooltip(event) {
    // If click on same element stop event to it wont remove it from dom
    // Also Helps Prevent GhostClick on Phones
    if(event.type == "keydown" && event.keyCode == 9) {
      this.isTabKey = true
    }
    if (event.type == "click" && this.service.commonSetting.isMobileDevice) {
      event.stopPropagation();
      event.preventDefault();
      return;
    }
    // Answer Tooltip
    if (this.IsAnswerToolTip) {
      // Do something with 'event'
      event.stopPropagation();
      if (this.ele.nativeElement.hasAttribute("data-tooltipcount")) {
        let existingTT = document.querySelector(
          "[data-tooltip= '" +
          this.ele.nativeElement.getAttribute("data-tooltipcount") +
          "']"
        );

        $(existingTT).remove();
      }

      let tooltipCount = document.querySelectorAll("[data-tooltipcount]")
        .length;
      this.ele.nativeElement.setAttribute(
        "data-tooltipcount",
        tooltipCount + 1
      );

      let tooltip = document.createElement("div");

      let top = $(this.ele.nativeElement).offset().top;
      let left = $(this.ele.nativeElement).offset().left;
      // If Hidden Question IN Preview tooltip
      tooltip.setAttribute("data-tooltip", "" + (tooltipCount + 1));
      document.body.appendChild(tooltip);
      if (this.IsHiddenQToolTip) {
        tooltip.classList.add("tooltip_container");
        tooltip.classList.add("hiddenQ-tooltip");
        tooltip.classList.add("active");
        tooltip.innerHTML =
          `<div class="hdn-icn-div" ><img width="30px" height="30px" src="${this.imageFolder}/imagesNew/PM/save_img.png" border="0" /><span>This question will be hidden from participants.</span></div>`;
        this.ele.nativeElement.setAttribute("aria-label","This question will be hidden from participants.")
        // Calculate Width & Height of icon position + tooltip size
        let totalTooltipWidth = left + tooltip.offsetWidth;
        let totalTooltipHeight = top + tooltip.offsetHeight + 25;

        if (this.service.commonSetting.isMobileDevice && !this.service.isRTL) {
          totalTooltipWidth -= left;
        }

        // If its going outside body show it at right hand
        if (totalTooltipWidth > document.body.offsetWidth) {
          tooltip.style.left = "auto";
          tooltip.style.right =
            document.body.offsetWidth -
            $(this.ele.nativeElement).offset().left -
            16 +
            "px"; // 2px for arrow 14 px for icon size
          tooltip.classList.add("hiddenQ-right-arrow");
        }
        // else display at left hand
        else {
          tooltip.style.left = left - 2 + "px";
        }

        // If its going outside body show it at top side
        if (
          totalTooltipHeight >
          document.body.offsetHeight + $(window).scrollTop()
        ) {
          tooltip.style.top = top - tooltip.offsetHeight - 10 + "px";
          tooltip.classList.add("hiddenQ-down-arrow");
        }
        // else display at bottom hand
        else {
          tooltip.style.top = top + 25 + "px";
        }

      }
      // If Answer Quota Tooltip
      else {
        tooltip.classList.add("tooltip_container");
        tooltip.classList.add("answer");
        tooltip.classList.add("active");
        tooltip.innerHTML = this.dataContext;
        this.ele.nativeElement.setAttribute("aria-label",this.dataContext)
        tooltip.style.left = left - 30 + "px";
        tooltip.style.top = top + 25 + "px";
      }
    }
    // Hint Tooltip
    else {
      if(event.type == "mouseover") {
        return;
      }
      // Do something with 'event'
      event.stopPropagation();
      let tooltipCount = document.querySelectorAll("[data-tooltipcount]")
      .length;
      this.ele.nativeElement.setAttribute(
        "data-tooltipcount",
        tooltipCount + 1
        );

      if(this.isShownHint) {
        this.isShownHint = false;
        $("#tooltip-" + this.qid).remove();
        return;
      }

      if(event.type == "click" || event.type == "touchstart") {
        this.isShownHint = true;
      }
      if($("#tooltip-" + this.qid).length > 0) {
        $("#tooltip-" + this.qid).remove()
      }
      let tooltip = document.createElement("div");
      tooltip.classList.add("tooltip_container");
      tooltip.classList.add("datatooltip");
      tooltip.id = "tooltip-" + this.qid;
      tooltip.classList.add("active");
      tooltip.setAttribute("data-tooltip", "" + (tooltipCount + 1));
      tooltip.innerHTML = this.dataContext;
      this.ele.nativeElement.setAttribute("aria-label",`Tip: ${this.dataContext}`);
      this.ele.nativeElement.setAttribute("role","tooltip");
      document.body.appendChild(tooltip);
      if (this.service.commonSetting.isMobileDevice) {
        tooltip.classList.add("mobile-hint");
        $(tooltip).append('<span class="qhint-tooltip-arrow"></span>');
        let top = $(this.ele.nativeElement).offset().top;
        let left = $(this.ele.nativeElement).offset().left;
        tooltip.style.top = top + 25 + "px";
        tooltip.style.left = left - 30 + "px";
        var diff = ($('.mobile-wrapper').outerWidth() - ($(tooltip).outerWidth() + $(tooltip).offset().left + 20));
        if (diff < 0) {
          var checkLeft = left - 30 + diff;
          if (checkLeft < 0) {
            tooltip.style.left = 0 + "px";
          } else {
            tooltip.style.left = left - 30 + diff + "px";
          }
        }
        if ($(tooltip).outerHeight() > 50) {
          tooltip.style.left = 10 + "px";
          if(($(this.ele.nativeElement).offset().left - ($(tooltip).offset().left + $(tooltip).outerWidth()) > 0)) {
            var diff = $(this.ele.nativeElement).offset().left - ($(tooltip).offset().left + $(tooltip).outerWidth());
            tooltip.style.left = $(tooltip).offset().left + diff + 30 + "px";
          }
        }
        var arrowLeft = $(this.ele.nativeElement).offset().left - $(tooltip).offset().left;
        $(tooltip).find('.qhint-tooltip-arrow').css({ 'left': arrowLeft + "px" });
      } else {
        let top = $(this.ele.nativeElement).offset().top;
        let left = $(this.ele.nativeElement).offset().left;
        tooltip.style.top = top + 25 + "px";
        tooltip.style.left = left - 30 + "px";
      }
      var toolTipText = $(tooltip).text();
        $(tooltip).html('');
        $(tooltip).append('<div class="tooltip-text-wrapper">' + toolTipText + '</div>');
        $('.tooltip_container.active .tooltip-text-wrapper').niceScroll({
          background: '#000000',
          cursorcolor: '#9E9D9D',
          cursorwidth: '10px',
          autohidemode: false
      });
      $('.tooltip_container.active .tooltip-text-wrapper').getNiceScroll.resize();
    }
  }
}
